<template>
  <div class="container-box">
    <QS-scroller-box>
     <QS-h3-title>
      <template slot="title">{{ pageTitle }}</template>
      <div class="splitline" />
    </QS-h3-title>
    <QS-h4-title title="方案基本信息" />
    <!--方案id和创建时间单独提出来，解决编辑时排版混乱的问题-->
    <form-text-box
      v-if="id"
      :dataList="baseEditConfig"
      :model="baseDefaultValue"
      :column="2"
    />
    <form-text-box
      ref="baseSearchBox"
      :dataList="baseCloumn"
      :model="baseDefaultValue"
      :column="2"
      :rules="baseRules"
    />
    <QS-h4-title title="租赁规则配置" />
    <!-- 确认租赁信息 -->
    <schemeRentInfo
      ref="schemeRentInfo"
      :defaultRentInfo="leaseInfoParams"
      :tableData="defaultTable"
      @updateInfo="updateRentDateInfo"
    />
    <!-- 租赁支付计划表格 -->
    <schemeRentLeasePlanInfo
      ref="schemeRentLeasePlanInfo"
      :rentDateInfo="rentDateInfo"
      :defaultTableData="feeTableData"
      @autoAnchor="autoAnchor"
    />
     <template slot="bottomAction">
        <el-button @click="goPageBacks" size="mini">取消</el-button>
        <el-button
          :loading="oLoading.submit"
          type="primary"
          size="mini"
          @click="submitHandle"
        >提交</el-button>
     </template>
   </QS-scroller-box>
 </div>
</template>
<script>
import { createPlanScheme, editEnterPlanScheme } from '@/api/domain/purchase.js'
// 组件
import schemeRentInfo from '@/components/rentCalculateConfig/schemeRentInfo.vue'
import schemeRentLeasePlanInfo from '@/components/rentCalculateConfig/schemeRentLeasePlanInfo.vue'
// mixin
import addMixin from '../mixin/indexNew.js'
import { MODE_TYPE, MODE_TYPE_TEXT } from '../const.js'
import { omit } from 'lodash'
import { CAR_MODEL_FILTER_SCENE } from '@/config/carManage'

export default {
  name: 'AddEnterEditNew',
  mixins: [addMixin],
  components: {
    schemeRentInfo,
    schemeRentLeasePlanInfo,
  },
  props: {
    // 编辑模式
    mode: {
      type: String,
      default: MODE_TYPE.ADD,
    },
  },
  data() {
    return {
      leaseInfoParams: {
        rentCategory: '', // 类别
        rentPeriod: '', // 预计租赁周期
        presentDays: '', // 赠送天数
        rentPeriodType: '', // 租赁周期单位
      },
      rentDateInfo: {
        rentCategory: '', // 类别
        rentPeriod: '', // 预计租赁周期
        presentDays: '', // 赠送天数
        rentPeriodType: '', // 租赁周期单位
      },
      pageTitle: `${MODE_TYPE_TEXT[this.mode]}企业租赁方案`,
      baseDefaultValue: {
        orderTypeName: '企业订单',
        brandId: '',
        modelId: '',
      },

      defaultTable: [],
      feeTableData: [],
      id: '',
      baseEditConfig: [
        {
          el: 'text',
          itemConfig: {
            label: '方案ID',
            prop: 'id',
          },
        },
        {
          el: 'text',
          itemConfig: {
            label: '创建时间',
            prop: 'gmtCreate',
          },
        },
      ],
    }
  },
  computed: {
    baseCloumn() {
      return [
        {
          el: 'input',
          itemConfig: {
            label: '方案名称',
            prop: 'name',
          },
          elConfig: {
            placeholder: '不对外展示，最多20字',
            clearable: true,
            maxlength: 20,
          },
        },
        {
          el: 'text',
          itemConfig: {
            label: '订单类型',
            prop: 'orderTypeName',
          },
        },
        {
          el: 'CarBrandSeriesModel',
          itemConfig: {
            prop: 'brandSeriesModel',
            ref: 'brandSeriesModelRef',
          },
          elConfig: {
            showModel: true,
            filterScene: CAR_MODEL_FILTER_SCENE.IN_STOCK,
          },
          render: 'CarBrandSeriesModel',
        },
      ]
    },
  },
  watch: {
    'baseDefaultValue.brandSeriesModel': {
      handler(val) {
        const { brandId, seriesId, modelId } = val
        this.baseDefaultValue.brandId = brandId
        this.baseDefaultValue.seriesId = seriesId
        this.baseDefaultValue.modelId = modelId
        this.$nextTick(() => {
          this.$refs.baseSearchBox.getRefs().clearValidate('brandId')
          this.$refs.baseSearchBox.getRefs().clearValidate('modelId')
        })
      },
      deep: true,
    },
  },
  methods: {
    updateRentDateInfo(val, feeTableData) {
      this.rentDateInfo = {
        ...val,
      }
      this.feeTableData = feeTableData
    },
    autoAnchor(toastFlag) {
      this.$refs.schemeRentInfo.autoAnchorPoint(toastFlag)
    },
    // 设置值
    // eslint-disable-next-line vue/no-unused-properties
    setData(data) {
      this.baseDefaultValue.id = this.id
      this.baseDefaultValue.gmtCreate = data.gmtCreate
      this.baseDefaultValue.name = data.name
      this.baseDefaultValue.brandId = !this.validateIsEmptyValue(data.brandId)
        ? Number(data.brandId)
        : ''
      this.baseDefaultValue.seriesId = !this.validateIsEmptyValue(data.seriesId)
        ? Number(data.seriesId)
        : ''
      this.baseDefaultValue.modelId = !this.validateIsEmptyValue(data.modelId)
        ? Number(data.modelId)
        : ''
      this.baseDefaultValue.brandSeriesModel = {
        brandId: this.baseDefaultValue.brandId,
        seriesId: this.baseDefaultValue.seriesId,
        modelId: this.baseDefaultValue.modelId,
      }
      this.baseDefaultValue.introduction = data.introduction

      // 配置信息
      this.leaseInfoParams.rentCategory = data.rentCategory
      this.leaseInfoParams.rentPeriod = !this.validateIsEmptyValue(
        data.rentPeriod,
      )
        ? String(data.rentPeriod)
        : ''
      this.leaseInfoParams.presentDays = data.presentDays ? String(data.presentDays) : ''
      this.leaseInfoParams.rentPeriodType = data.rentPeriodType
      // PKXW-8650租赁方案配置这个需求本期不考虑集团租赁商城配置，只改动公司侧租赁方案配置，
      // 即只有公司侧预计租赁周期改为月/天配置，且为输入框
      // 只有公司侧编辑才会调用这个方法，所以租赁周期只有输入框，没有下拉框
      this.rentDateInfo = {
        ...this.leaseInfoParams,
      }
      this.defaultTable = data.orderPlanFeeList
    },
    // 提交事件
    submitHandle() {
      // 处理方案基本信息
      this.$refs.baseSearchBox.getRefs().validate((valid) => {
        if (!valid) {
          this.$message.error('请先将【方案基本信息】的必填字段填写完整')
          this.$refs.baseSearchBox.$el.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'start' })
          return
        }
        const baseInfoData = { ...this.baseDefaultValue }
        // 处理租赁基本信息
        const rentInfoData = this.$refs.schemeRentInfo.getFormData() // 确认租赁信息
        if (!rentInfoData) return // 表单未通过校验
        // 处理table
        const tableData = this.$refs.schemeRentLeasePlanInfo.getFormData() // table
        if (!tableData) return // table未通过校验

        delete baseInfoData.orderTypeName
        this.postParams = {
          orderType: 2, // 客户类型 2企业
          ...baseInfoData,
          ...rentInfoData,
          rentFeeList: tableData,
        }
        if (this.mode === MODE_TYPE.EDIT && this.id) {
          this.editLeasingSchemeConfigFun()
        } else {
          this.addEnterPlanSchemeFn()
        }
      })
    },
    // 新增企业租赁方案
    async addEnterPlanSchemeFn() {
      const addPostParams = { ...this.postParams }
      if (!addPostParams.presentDays) {
        addPostParams.presentDays = 0
      }
      // 集团侧 & 从新增产品跳转过来带的 goUpState 参数的，添加 state ，可使得方案直接上架，保证从此页面再跳转回新增商品的时候，在选择租赁方案的时候可以选择上
      if (this.$route.query.goUpState) {
        addPostParams.state = 10
      }
      this.oLoading.submit = true
      const res = await createPlanScheme(omit(addPostParams, 'id')).finally(() => { this.oLoading.submit = false })
      if (res.code === 1) {
        this.$message.success('添加成功')
        this.goPageBacks(true)
      }
    },
    // 编辑企业租赁方案
    async editLeasingSchemeConfigFun() {
      this.oLoading.submit = true
      const params = {
        ...this.postParams,
        id: this.id,
      }
      if (!this.postParams.maintenancePlanId) {
        params.maintenancePlanId = 0
      }
      const res = await editEnterPlanScheme(params).finally(() => {
        this.oLoading.submit = false
      })
      if (res.code === 1) {
        this.$message.success('修改成功')
        this.goPageBacks(true)
      }
    },
  },
}
</script>
<style lang="scss" scoped>
.orderConfig {
 margin-bottom: 0;
}
.lessMonth {
 margin-top: 20px;
}
.qs-scrollerBox {
  margin-right: 0
}
</style>
